module.exports = __webpack_public_path__ + "static/media/mr.19451e08.svg";